import React, { useState, useEffect } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { createCustomerCategory, fetchCustomerTypes } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function CustomerCategoryCreatePage() {
  const { businessDomainId, businessUnitId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [customerTypes, setCustomerTypes] = useState([]);
  const [form, setForm] = useState({
    customerCategoryName: "",
    customerTypeId: "",
    customerTypeName: "",
    customerCategoryDescription: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const types = await fetchCustomerTypes(businessDomainId);
        setCustomerTypes(Array.isArray(types) ? types : []);
      } catch (e) { /* ignore */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessDomainId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleTypeChange = (e) => {
    const selected = customerTypes.find((ct) => ct.customerTypeId === e.target.value);
    setForm({
      ...form,
      customerTypeId: e.target.value,
      customerTypeName: selected ? selected.customerTypeName : "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createCustomerCategory({
        companyId: COMPANY_ID,
        businessDomainId,
        businessUnitId,
        customerCategoryName: form.customerCategoryName,
        customerTypeId: form.customerTypeId,
        customerTypeName: form.customerTypeName,
        customerCategoryDescription: form.customerCategoryDescription || null,
      });
      notify.success(t("message.create.success"));
      navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/customer-categories`, { replace: true });
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("customerCategory.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* 顧客カテゴリ名 */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth required
              label={t("customerCategory.name")}
              name="customerCategoryName"
              value={form.customerCategoryName}
              onChange={handleChange}
            />
          </Grid>

          {/* 顧客タイプ選択 */}
          <Grid size={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>{t("customerCategory.customerType")}</InputLabel>
              <Select
                value={form.customerTypeId}
                onChange={handleTypeChange}
                label={t("customerCategory.customerType")}
              >
                {customerTypes.map((ct) => (
                  <MenuItem key={ct.customerTypeId} value={ct.customerTypeId}>
                    {ct.customerTypeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* 説明 */}
          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("customerCategory.description")}
              name="customerCategoryDescription"
              value={form.customerCategoryDescription}
              onChange={handleChange}
            />
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/customer-categories`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
